var map = {
	"./asafo-agyei.jpg": "3a2f",
	"./backup/asafo-agyei.jpg": "2f14",
	"./backup/cornelius.jpg": "fccc",
	"./backup/haertel.jpg": "97a1",
	"./backup/hamburg.jpg": "702a",
	"./backup/honnen.jpg": "001c",
	"./backup/kleemann.jpg": "2821",
	"./backup/kluever.jpg": "ab23",
	"./backup/kuever.jpg": "f48e",
	"./backup/liebert.jpg": "b361",
	"./backup/muegge.jpg": "3a09",
	"./bromberger.png": "e112",
	"./cornelius.png": "5c95",
	"./employee_dummy.jpg": "7c3d",
	"./exner.png": "90d3",
	"./grochowski.png": "b227",
	"./haertel.png": "1a51",
	"./hamburg.png": "99fa",
	"./honnen.jpg": "bd45",
	"./kirchhoff.png": "9d69",
	"./kleemann.jpg": "70ed",
	"./kluever.jpg": "a854",
	"./kuever.jpg": "8230",
	"./liebert.png": "a6d5",
	"./muegge.png": "e529",
	"./old/cornelius.jpg": "4895",
	"./old/exner.jpg": "136f",
	"./old/grochowski.jpg": "49ab",
	"./old/haertel.jpg": "b2ba",
	"./old/hamburg.jpg": "8e3a",
	"./old/liebert.jpg": "f03d",
	"./old/muegge.jpg": "eb2a",
	"./old/zeka.jpg": "d2a4",
	"./zeka.png": "699d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fd1e";